import { ProductPriceCreateDto, ProductPriceUpdateDto } from "../../../api";
import ProductPriceModalForm from "../productPriceModalForm/productPriceModalForm";

export default function ProductPriceModalFormAddContainer(props: ProductPriceModalFormAddContainerProps) {
    return <>
        <ProductPriceModalForm
            isModalVisible={props.addFormVisibility}
            setModalVisibility={props.onFinish}
            onSubmit={props.onSubmit}
            modalTitle={props.title}
            saveButtonTitle="Submit"
            initialValues={props.ProductPriceToEdit!}
        />
    </>
}

interface ProductPriceModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    onSubmit: (values: ProductPriceCreateDto | ProductPriceUpdateDto) => Promise<any>,
    addFormVisibility: boolean,
    title: string,
    ProductPriceToEdit: ProductPriceUpdateDto | null
}
